<template>
  <div class="video-inner-plyr-hd" ref="videoPlayerSection">
    <video ref="PlyrVideoPlayer"></video>
  </div>
</template>

<script>
import Plyr from 'plyr';
import Hls from 'hls.js';
import 'plyr/dist/plyr.css';

export default {
  props: {
    vodLink: {
      type: String,
    },
  },
  data() {
    return {
      player: null,
      hls: null,
      options: {
        controls: [
          'play-large',
          'play',
          'mute',
          'progress',
          'volume',
          'settings',
          'quality',
          'fullscreen',
        ],
        settings: ['quality'],
        keyboard: { focused: true, global: true },
        autoplay: false,
      },
    };
  },
  mounted() {
    this.initPlayer();
  },
  methods: {
    pause(){
      this.$refs.PlyrVideoPlayer.pause();
    },
    play(){
      this.$refs.PlyrVideoPlayer.play();
    },
    initPlayer() {
      const video = this.$refs.PlyrVideoPlayer;

      if (Hls.isSupported()) {
        // Initialize HLS with autoStartLoad set to false
        this.hls = new Hls({ autoStartLoad: false });

        // Attach the HLS instance to the video element
        this.hls.attachMedia(video);

        // Listen for when HLS is attached to media
        this.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
          console.log('Video and HLS.js are now bound together!');

          // Load source only when the user starts playback
          video.addEventListener('play', this.startVideoLoad);
        });

        // Handle error events with detailed logging
        this.hls.on(Hls.Events.ERROR, (event, data) => {
          console.error('HLS.js Error:', data);
          if (data.fatal) {
            switch (data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR:
                console.error('Network error encountered, trying to recover...');
                this.hls.startLoad(); // Attempt to recover network errors
                break;
              case Hls.ErrorTypes.MEDIA_ERROR:
                console.error('Media error encountered, trying to recover...');
                this.hls.recoverMediaError();
                break;
              default:
                this.destroyHls();
                break;
            }
          }
        });

        // Initialize Plyr player
        this.player = new Plyr(video, this.options);
      } else {
        // If HLS is not supported, use standard video element handling
        video.src = this.vodLink;
        video.playsInline = true;
        this.player = new Plyr(video, this.options);
      }
    },
    startVideoLoad() {
      if (this.hls && !this.hls.url) {
        // Load the video source and start loading segments only once
        this.hls.loadSource(this.vodLink);
        this.hls.startLoad();
        console.log('HLS video source loaded and playback started.');
      }
    },
    destroyHls() {
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
        console.log('HLS instance destroyed.');
      }
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.destroy();
      this.player = null;
      console.log('Plyr player destroyed.');
    }
    this.destroyHls();
  },
};
</script>

<style lang="scss">
.video-inner-plyr-hd {
  // Style adjustments for Plyr player
  .plyr__control[data-plyr='fast-forward'],
  .plyr__control[data-plyr='rewind'] {
    img {
      width: 22px;
    }
  }

  .plyr__volume input[type='range'] {
    direction: ltr;
  }

  .plyr.plyr--loading::after {
    content: '';
    position: absolute;
    width: 4rem;
    height: 4rem;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 8px solid transparent;
    border-top-color: #00b2ff;
    border-radius: 50%;
    animation: button-loading-spinner 1s ease infinite;
  }

  @keyframes button-loading-spinner {
    from {
      transform: rotate(0turn);
    }

    to {
      transform: rotate(1turn);
    }
  }
}
</style>
